module.exports = __webpack_public_path__ + "static/media/iPAD-Animation.61efb1ee.mp4";